import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";

const equipmentProperty = new AthubRestResource({server: DCIM_SERVER, resource: 'equipment-property'});

equipmentProperty.getRowProperties = (rowId, config) => {
    return equipmentProperty.handlePromise(
        athubAxios.get(`${equipmentProperty.server}/${equipmentProperty.resource}/property-value/row-id/${rowId}`,
            config));
};

export default equipmentProperty;
